import React, { useState, useEffect } from "react";
import Modal from "../components/modal";

console.log("Początek importu obrazów");
const images = require.context("../images/galery", false, /\.(png|jpe?g|svg)$/);

const imageFiles = images.keys().map(images);

const galleryImages = imageFiles
  .map((image, index) => ({
    id: index + 1,
    src: image,
    alt: `Image ${index + 1}`,
  }))
  .reverse();

const GalleryItem = ({ image, onClick }) => {
  return (
    <div
      className="GalleryItemWrap"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <img
        className="GalleryItemImg"
        src={image.src}
        alt={image.alt}
        loading="lazy"
      />

      <div className="GalleryItemOverlay" aria-hidden="true">
        <div className="ZoomIcon" title="Powiększ">
          {/* prosta lupka z plusem w SVG */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M21 21l-4.35-4.35"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M10.5 7v7M7 10.5h7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

const GalleryImages = () => {
  const [visibleImages, setVisibleImages] = useState(16);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const loadMoreImages = () => {
    setVisibleImages((prevVisibleImages) => prevVisibleImages + 20);
  };

  const openModal = (index) => {
    setSelectedImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  const handleNext = () => {
    if (selectedImageIndex < galleryImages.length - 1) {
      setSelectedImageIndex(selectedImageIndex + 1);
    }
  };

  const handlePrev = () => {
    if (selectedImageIndex > 0) {
      setSelectedImageIndex(selectedImageIndex - 1);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });

    return () => {
      window.removeEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          closeModal();
        }
      });
    };
  }, []);

  return (
    <>
      <div className="ImagesContainer">
        {galleryImages.slice(0, visibleImages).map((image, index) => {
          return (
            <GalleryItem
              key={image.id}
              image={image}
              onClick={() => openModal(index)}
            />
          );
        })}

        {selectedImageIndex !== null && (
          <Modal
            image={galleryImages[selectedImageIndex]}
            onClose={closeModal}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        )}
      </div>
      {visibleImages < galleryImages.length && (
        <div className="centerer">
          <button onClick={loadMoreImages}>Załaduj więcej</button>
        </div>
      )}
    </>
  );
};

export default GalleryImages;
